module.exports = __webpack_public_path__ + "img/espaço-1.16a49378.jpeg";